import { SET_LOADER } from "./actions/ui";
import { API_SUCCESS, API_ERROR, LOGIN_SUCCESS, PASSWORD_RESET_REQUIRED, BLOGS_FETCHED, BLOG_FETCHED, CATEGORIES_FETCHED, LANGUAGES_FETCHED, ROLES_FETCHED, USERS_FETCHED, UP_PGR, DN_PGR, BLOG_SAVED, BLOG_UPDATED, TRANSLATED, FETCH_BLOG, FETCH_LANGUAGES, FETCH_CATEGORIES, STATICS_FETCHED, STATICS_UPDATED, DEVICES_FETCHED, REGISTER_REQUESTED, ATTENDANCE_FETCHED, CUSTOM_MIDDLE_RESPONSE } from "./actions/api";
import { LOGOUT } from "./actions/auth";
// import Cookies from 'cookie';

export default (
    state = {
        isAuthUser: !!getCookie("user"),
        // isAuthUser1: () => !!getCookie("user") && !passwordResetRequired,
        // isAuthUser: false,
        user: getCookie("user") || {},
        // user: {},
        isLoading: false,
        error: null,
        passwordResetRequired: false,
        blogs: null,
        categories: null,
        customMiddle: {},
    },
    action
) => {
    switch (action.type) {
        case API_SUCCESS:
            // localStorage.setItem("user", JSON.stringify(action.payload.result));
            // console.log('logged in');
            return { ...state, isLoading: false };
        case API_ERROR:
            return { ...state, isLoading: false };
        case SET_LOADER:
            return { ...state, isLoading: action.payload };
        case LOGOUT:
            setCookie("user", null, -1);
            return { ...state, isAuthUser: false, user: {} };
        case LOGIN_SUCCESS:
            console.log('in login success');
            // localStorage.setItem("user", JSON.stringify(action.payload));
            setCookie('user', JSON.stringify(action.payload), 3000)
            console.log('logged in');
            return { ...state, isAuthUser: true, user: action.payload, passwordResetRequired: false, isLoading: false, alert: "logged in" };
        case PASSWORD_RESET_REQUIRED:
            console.log('in reset req');
            // localStorage.setItem("user", JSON.stringify(action.payload.result));
            // console.log('logged in');
            return { ...state, isAuthUser: false, isLoading: false, user: action.payload, passwordResetRequired: true };
        case BLOGS_FETCHED:
            return { ...state, blogs: action.payload, isLoading: false };
        case BLOG_FETCHED:
            return { ...state, blog: { state: 1, data: action.payload }, isLoading: false };
        case TRANSLATED:
            return { ...state, translated: action.payload, isLoading: false };
        case USERS_FETCHED:
            return { ...state, users: action.payload, isLoading: false };
        case CATEGORIES_FETCHED:
            return { ...state, categories: { state: true, data: action.payload }, isLoading: false }
        case LANGUAGES_FETCHED:
            return { ...state, languages: { state: true, data: action.payload }, isLoading: false }
        case ROLES_FETCHED:
            return { ...state, roles: action.payload, isLoading: false }
        case DEVICES_FETCHED:
            return { ...state, devices: action.payload, isLoading: false }
        case ATTENDANCE_FETCHED:
            return { ...state, attendance: action.payload, isLoading: false }
        case REGISTER_REQUESTED:
            return { ...state, registerRequestData: action.payload, isLoading: false }
        case UP_PGR:
            return { ...state, uploadProgress: action.payload }
        case DN_PGR:
            return { ...state, downloadProgress: action.payload }
        case BLOG_SAVED:
            return { ...state, blogSaved: true, isLoading: false }
        case BLOG_UPDATED:
            return { ...state, blogUpdated: true, isLoading: false }
        case FETCH_BLOG:
            return { ...state, blog: { state: false, data: null } }
        case FETCH_CATEGORIES:
            return { ...state, categories: { state: false, data: null } }
        case FETCH_LANGUAGES:
            return { ...state, languages: { state: false, data: null } }
        case STATICS_FETCHED:
            return { ...state, statics: { state: true, data: action.payload }, isLoading: false }
        case STATICS_UPDATED:
            return { ...state, staticsUpdated: true, isLoading: false }
        case CUSTOM_MIDDLE_RESPONSE:
            return { ...state, isLoading: false, customMiddle: { ...state.customMiddle, [action.payload.requestedBy]: action.payload.payload } }
        // case CUSTOM_MIDDLE_RESET:
        //     return { ...state, customMiddle: { ...state.customMiddle, [action.payload.requestedBy]: undefined } }
        default:
            return { ...state };
    }
};


function setCookie(cname, cvalue, exSeconds) {
    var d = new Date();
    d.setTime(d.getTime() + (exSeconds * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return JSON.parse(c.substring(name.length, c.length));
        }
    }
    return "";
}

export { getCookie, setCookie };